export default "__VITE_ASSET__Bf4CmOwL__"